import React from 'react'

const SnagImport = ({ appURL }) => {
  return (
    <iframe src={appURL} style={{ width: '100%', height: '100%' }}></iframe>
  )
}

export default SnagImport